import React from "react";
import { Form, Input, Button, Card, Row, Col, Select, message } from "antd";
import PropTypes from "prop-types";
import API from "api/endpoints";
import axiosInstance from "api/axiosInstance";
import { LeaveTypeEnumLabel } from "Constants/Enums/LeavePolicyEnum";
import { error } from "highcharts";

const { Option } = Select;

export default function AddPolicyInputFields({ onSubmitSuccess }) {
  const [form] = Form.useForm();
  const [loading, setLoading] = React.useState(false);
  const [submitting, setSubmitting] = React.useState(false);
  const handleSubmit = async (values) => {
    if (submitting) {
      console.error("Already submitting, returning early");
      return;
    }

    setSubmitting(true);
    setLoading(true);

    try {
      const payload = {
        policyName: values.policyName.trim(),
        leaveType: Number(values.leaveType),
        grantedDaysPerYear: Number(values.grantedDaysPerYear),
        description: values.description.trim(),
      };

      await axiosInstance.post(API.leavePolicy.addLeavePolicy, payload);

      message.success("Leave policy added successfully!");
      form.resetFields();
      onSubmitSuccess();
    } catch (error) {
      console.error("Submission error:", error);
      const errorMessage =
        error.response?.data?.details || "Something went wrong. Please try again.";

      message.error(errorMessage);
    } finally {
      setLoading(false);
      setSubmitting(false);
    }
  };

  const handleReset = () => {
    form.resetFields();
    setLoading(false);
    setSubmitting(false);
    message.info("Form has been reset");
  };

  const handleCancel = () => {
    handleReset();
    onSubmitSuccess();
  };

  return (
    <Card
      title="Add Leave  Policy"
      className="card-professional"
      extra={
        <Button type="link" onClick={handleReset} disabled={loading}>
          Reset Form
        </Button>
      }
    >
      <Form layout="vertical" form={form} onFinish={handleSubmit}>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Policy Name *"
              name="policyName"
              rules={[{ required: true, message: "Policy name is required" }]}
            >
              <Input placeholder="Enter policy name" disabled={loading} />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label="Leave Type *"
              name="leaveType"
              rules={[{ required: true, message: "Leave type is required" }]}
            >
              <Select placeholder="Select Leave Type" disabled={loading}>
                {Object.entries(LeaveTypeEnumLabel).map(([key, label]) => (
                  <Option key={key} value={key}>
                    {label}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Granted Days Per Year *"
              name="grantedDaysPerYear"
              rules={[{ required: true, message: "Granted days are required" }]}
            >
              <Input type="number" placeholder="Enter number of granted days" disabled={loading} />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label="Description *"
              name="description"
              rules={[{ required: true, message: "Description is required" }]}
            >
              <Input.TextArea
                rows={2}
                placeholder="Enter leave policy description"
                disabled={loading}
              />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item>
          <Button
            className="btn-primary"
            htmlType="submit"
            loading={loading}
            style={{ marginRight: 10 }}
          >
            Submit
          </Button>
          <Button
            type="default"
            onClick={handleCancel}
            disabled={loading}
            style={{ marginRight: 10 }}
          >
            Cancel
          </Button>
          <Button type="dashed" onClick={handleReset} disabled={loading}>
            Reset
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
}

AddPolicyInputFields.propTypes = {
  onSubmitSuccess: PropTypes.func.isRequired,
};
